import {
  Stepper,
  styled,
  Step as MuiStep,
  StepLabel as MuiStepLabel,
} from "@mui/material";
import { Check } from "theme/icons";
import Typography from "../Typography/Typography.tsx";

type StepIconComponentProps = {
  active?: boolean;
  completed?: boolean;
  step: number
};

type ProgressStepsProps = {
  activeStep: number;
  steps: string[];
};

const StepIconComponent = ({ completed, active, step }: StepIconComponentProps) => {

  if (completed) {
    return <Check/>;
  }

  if (active) return step;

  return step;
};

export const Step = styled(MuiStep)(({ theme }) => {
  return {
    padding: theme.spacing(0, 2),
    position: "relative",

    "& .MuiStepLabel-iconContainer": {
      padding: 0,
      borderRadius: "5px",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.common.black,
      fontWeight: 500,
      fontSize: '16px',
      color: theme.palette.common.black,
      height: '36px',
      width: '36px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    "& .MuiStepLabel-iconContainer.Mui-completed": {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.text.secondary,
      borderColor: theme.palette.success.main,
    },

    "& .MuiStepLabel-iconContainer.Mui-active": {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.text.secondary,
    }
  }
});

export const StepLabel = styled(MuiStepLabel)(({ theme }) => {
  return {
    userSelect: "none",

    "& .MuiStepLabel-labelContainer": {
      marginLeft: theme.spacing(1)
    },


    "&.Mui-disabled": {

      "& .MuiStepLabel-labelContainer": {
        color: theme.palette.text.placeholder,
      },
    },
  };
});

const ProgressSteps = ({ activeStep, steps }: ProgressStepsProps) => {
  return (
    <Stepper activeStep={activeStep - 1}>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel icon={null} StepIconComponent={props => <StepIconComponent step={index + 1} {...props}/>}>
            <Typography fontSize='16px' variant='body1' weight='semiBold'>{label}</Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default ProgressSteps;
